import { getImageUrl } from "@/utils/imageUrl";

const CLOUDINARY_HOST = "https://res.cloudinary.com";

function buildBaseUrl(url) {
  if (!url) {
    return "";
  }

  const segments = url.split("/upload/");
  if (!segments[1]) {
    return getImageUrl(url);
  }

  const cloudSegments = url.split("/");
  const cloudName = cloudSegments[3];
  if (!cloudName) {
    return getImageUrl(url);
  }

  return {
    cloudName,
    assetPath: segments[1],
  };
}

export default {
  methods: {
    idCloudinaryImg(url) {
      const data = buildBaseUrl(url);
      if (typeof data === "string") {
        return data;
      }

      const transformedUrl = `${CLOUDINARY_HOST}/${data.cloudName}/image/upload/c_crop,dpr_auto,g_custom,q_auto:best/${data.assetPath}`;
      return getImageUrl(transformedUrl);
    },
    idCloudinaryAwards(url, width, height) {
      const data = buildBaseUrl(url);
      if (typeof data === "string") {
        return data;
      }

      if (!width || !height) {
        return getImageUrl(url);
      }

      const transformedUrl = `${CLOUDINARY_HOST}/${data.cloudName}/image/upload/dpr_auto,f_auto,fl_lossy,q_auto/c_crop,g_custom/h_${height},w_${width},b_auto,c_pad/${data.assetPath}`;
      return getImageUrl(transformedUrl);
    },
  },
};
